import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useFollowedPathCirrStatus } = getCRUDHooks({
  entityName: 'followedPathCirrStatus',
  get: ({ userId }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).followedPathCirrStatus.find(),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useFollowedPathCirrStatus,
};
